import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ILegalDocumentActionTypes } from "../../action-types/legal-document/ILegalDocumentActionTypes";
import { ILegalDocumentReducer } from "../../page-state-model/legal-document/ILegalDocumentReducer";

const iniState: ILegalDocumentReducer = {
    documents: [],
    isShowEditModal: false,
    status: ePageBaseStatus.is_not_initialization
}
export const legalDocumentReducer = (state: ILegalDocumentReducer = iniState, action: ILegalDocumentActionTypes): ILegalDocumentReducer => {
    switch (action.type) {
        case "LEGAL_DOCUMENT_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "LEGAL_DOCUMENT_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                documents: action.payload
            }
        case "LEGAL_DOCUMENT_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "LEGAL_DOCUMENT_SHOW_EDIT_MODAL":
            return {
                ...state,
                documentEditing: action.payload,
                isShowEditModal: true
            }
        case "LEGAL_DOCUMENT_CLOSE_EDIT_MODAL":
            return {
                ...state,
                documentEditing: undefined,
                isShowEditModal: false
            }
        case "LEGAL_DOCUMENT_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "LEGAL_DOCUMENT_SAVE_SUCESSS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "LEGAL_DOCUMENT_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "LEGAL_DOCUMENT_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "LEGAL_DOCUMENT_DELETE_SUCESSS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "LEGAL_DOCUMENT_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }

        default:
            return state;
    }
}